export const pieData = [
  { name: 'No Show', value: 400, color: 'rgba(28, 189, 151, 0.3)' },
  { name: 'Successful bookings', value: 300, color: '#1CBD97' },
  { name: 'Alerts', value: 300, color: 'rgba(28, 189, 151, 0.6)' }
];